export default [
    {
        path: '/user/expertise-country',
        props: true,
        component: () => import('@/views/User/ExpertiseCountry'),
    },
    {
        path: '/user/:id/expertise-country',
        props: true,
        component: () => import('@/views/User/ExpertiseCountry/Show'),
    },
];
